import { Controller } from "@hotwired/stimulus"

// Reveals the remaining facet options (beyond the first five) in place, so each
// option is rendered exactly once.
export default class extends Controller {
  static targets = ["more", "toggle"]

  toggle() {
    this.moreTarget.hidden = !this.moreTarget.hidden
    this.toggleTarget.textContent = this.moreTarget.hidden ? "Show all" : "Show fewer"
  }
}
